import cookie from "js-cookie";

const handleTaxToggle = () => {
	const taxTrigger = document.querySelector(".js-tax-toggle");

	if (!taxTrigger) return;

	taxTrigger.addEventListener("click", () => {
		const taxSwitchetText = taxTrigger.querySelector("span");
		const currentTaxStatus =
			cookie.get("woocommerce_show_tax") === "true" ? true : false;

		taxSwitchetText.textContent = !currentTaxStatus ? "Inc VAT" : "Ex VAT";
		taxTrigger.classList.toggle("is-active");
	});
};

export default handleTaxToggle;
